import type { App } from 'vue';

import EditorJS from '../EditorJS/EditorJS.vue';
import Navbar from '../NavBar/NavBar.vue';
import WAccordion from './WAccordion/WAccordion.vue';
import WAccordionItem from './WAccordion/WAccordionItem.vue';
import WAlertIcon from './WAlertIcon/WAlertIcon.vue';
import WAlertModal from './WModal/WAlertModal.vue';
import WAvatar from './WAvatar/WAvatar.vue';
import WAvatarList from './WAvatar/WAvatarList.vue';
import WButton from './WButton/WButton.vue';
import WButtonOptions from './WButtonOptions.vue';
import WCheckbox from './WCheckbox/WCheckbox.vue';
import WContextMenu from './WContextMenu/WContextMenu.vue';
import WContextMenuItem from './WContextMenu/WContextMenuItem.vue';
import WChip from './WChip/WChip.vue';
import WCollapsible from './WCollapsible/WCollapsible.vue';
import WDatePicker from './WDatePicker/WDatePicker.vue';
import WDrawer from './WDrawer/WDrawer.vue';
import WDropdownMenu from './WDropdownMenu/WDropdownMenu.vue';
import WDropdownMenuButton from './WDropdownMenu/WDropdownMenuButton.vue';
import WDropdownMenuItem from './WDropdownMenu/WDropdownMenuItem.vue';
import WDropdownTextfield from './WDropdownTextfield/WDropdownTextfield.vue';
import WFileCard from './File/WFileCard.vue';
import WFileUpload from './File/WFileUpload.vue';
import WFooter from './WFooter/WFooter.vue';
import WIconButton from './WButton/WIconButton.vue';
import WInputSearch from './WInputSearch/WInputSearch.vue';
import WLoading from './WLoading/WLoading.vue';
import WLoadingSkeleton from './WLoadingSkeleton/WLoadingSkeleton.vue';
import WHorizontalLoader from './WHorizontalLoader/WHorizontalLoader.vue';
import WLogo from './WLogo/WLogo.vue';
import WMedia from './WMedia/WMedia.vue';
import WModal from './WModal/WModal.vue';
import WPageLayout from '../layout/WPageLayout.vue';
import WPagination from './WPagination/WPagination.vue';
import WPressable from './WButton/WPressable.vue';
import WRadioCard from './WRadioCard/WRadioCard.vue';
import WScaffold from '../layout/WScaffold.vue';
import WSelect from './WSelect/WSelect.vue';
import WSlider from './WSlider/WSlider.vue';
import WSnackbar from './WSnackbar/WSnackbar.vue';
import WSocialIcon from './WSocialIcon/WSocialIcon.vue';
import WStepper from './WStepper/WStepper.vue';
import WStepperItem from './WStepper/WStepperItem.vue';
import WSwitch from './WSwitch/WSwitch.vue';
import WTablePageIndex from './Table/WTablePageIndex.vue';
import WTablePageSize from './Table/WTablePageSize.vue';
import WTabs from './WTabs/WTabs.vue';
import WTabsSecondary from './WTabs/WTabsSecondary.vue';
import WTextArea from './WTextArea/WTextArea.vue';
import WTextField from './WTextField/WTextField.vue';
import WTimeline from './WTimeline/WTimeline.vue';
import WTimelineIcon from './WTimeline/WTimelineIcon.vue';
import WTimelineItem from './WTimeline/WTimelineItem.vue';
import WTitle from './WTitle/WTitle.vue';
import WTooltip from './WTooltip/WTooltip.vue';
import WTopBar from '../layout/WTopBar.vue';
import WTreeSelect from './WTreeSelect/WTreeSelect.vue';
import WBreadcrumbs from '../breadcrumbs/Breadcrumbs.vue';

// Add global access to all custom elements

export const loadElements = (app: App) => {
  app.component('w-accordion', WAccordion);
  app.component('w-accordion-item', WAccordionItem);
  app.component('w-alert-icon', WAlertIcon);
  app.component('w-alert-modal', WAlertModal);
  app.component('w-avatar', WAvatar);
  app.component('w-avatar-list', WAvatarList);
  app.component('w-button', WButton);
  app.component('w-button-options', WButtonOptions);
  app.component('w-checkbox', WCheckbox);
  app.component('w-chip', WChip);
  app.component('w-collapsible', WCollapsible);
  app.component('w-context-menu', WContextMenu);
  app.component('w-context-menu-item', WContextMenuItem);
  app.component('w-date-picker', WDatePicker);
  app.component('w-drawer', WDrawer);
  app.component('w-dropdown-menu', WDropdownMenu);
  app.component('w-dropdown-menu-button', WDropdownMenuButton);
  app.component('w-dropdown-menu-item', WDropdownMenuItem);
  app.component('w-dropdown-textfield', WDropdownTextfield);
  app.component('w-editor-js', EditorJS);
  app.component('w-file-card', WFileCard);
  app.component('w-file-upload', WFileUpload);
  app.component('w-footer', WFooter);
  app.component('w-icon-button', WIconButton);
  app.component('w-input-search', WInputSearch);
  app.component('w-loading', WLoading);
  app.component('w-horizontal-loader', WHorizontalLoader);
  app.component('w-loading-skeleton', WLoadingSkeleton);
  app.component('w-logo', WLogo);
  app.component('w-media', WMedia);
  app.component('w-modal', WModal);
  app.component('w-page-layout', WPageLayout);
  app.component('w-pagination', WPagination);
  app.component('w-pressable', WPressable);
  app.component('w-radio-card', WRadioCard);
  app.component('w-scaffold', WScaffold);
  app.component('w-select', WSelect);
  app.component('w-slider', WSlider);
  app.component('w-snackbar', WSnackbar);
  app.component('w-social-icon', WSocialIcon);
  app.component('w-stepper', WStepper);
  app.component('w-stepper-item', WStepperItem);
  app.component('w-switch', WSwitch);
  app.component('w-table-page-index', WTablePageIndex);
  app.component('w-table-page-size', WTablePageSize);
  app.component('w-tabs', WTabs);
  app.component('w-tabs-secondary', WTabsSecondary);
  app.component('w-textarea', WTextArea);
  app.component('w-textfield', WTextField);
  app.component('w-title', WTitle);
  app.component('w-timeline', WTimeline);
  app.component('w-timeline-icon', WTimelineIcon);
  app.component('w-timeline-item', WTimelineItem);
  app.component('w-tooltip', WTooltip);
  app.component('w-topbar', WTopBar);
  app.component('w-tree-select', WTreeSelect);
  app.component('w-breadcrumbs', WBreadcrumbs);

  // eslint-disable-next-line vue/multi-word-component-names
  app.component('Navbar', Navbar);
  app.component('w-navbar', Navbar);
};
